import { isPlatformEmbedded } from './platformEmbed';

/** Presentation ownership is separate from iframe messaging and sign-in. */
export function platformOwnsIdentity(): boolean {
  return isPlatformEmbedded() || window.bunkerDesktop?.platformShell === true;
}
